import * as d3 from "d3";
import * as utils from "../utils/utils.js";
import * as table from "../plots/table.js";
import * as geneView from "../geneView.js";

//let plotConfig;
let brushCoords;

let isBrushed = (brush_coords, cx, cy)=> {
    var x0 = brush_coords[0][0],
        x1 = brush_coords[1][0],
        y0 = brush_coords[0][1],
        y1 = brush_coords[1][1];
    return x0 <= cx && cx <= x1 && y0 <= cy && cy <= y1;
} 
let setPointColor = (brush_coords, cx, cy)=>{
    let color;
    if (brush_coords!=undefined){
        if (isBrushed(brush_coords, cx, cy)){
            color = "red"
        } else {
            color = utils.circle.c
        }
    } else {
        color= utils.circle.c
    }
    return color
}
let filterData = (data, brush_coords, scaleX, scaleY)=>{
    let filtered;
    if (brush_coords!=undefined){
        filtered = data.filter(function (d){
            return isBrushed(brush_coords, scaleX(d.x), scaleY(d.y));
        })
    } else {
        filtered = data;
    }
    return filtered;
}
let filterPoint = (data, series)=>{
    return data.filter(d=>d.series == series)
}
function createPlotConfig(config, userInput){
   let plotConfig = {
        width: d3.select(`#${config.rootId}`).node().clientWidth,
        height:  d3.select(`#${config.rootId}`).node().clientWidth,
        padding: config.padding
    }; 
    let axis = ()=>{
        let type,
            yTitle, 
            xTitle;

        if (userInput.scatter){
            type="scatter";
            yTitle = `${utils.dict().screenLibrary[userInput.l]} ${utils.dict().cellLine[userInput.cl2]} ${utils.dict().conditionPair[userInput.c2]} - ${utils.extents()[type].yMetric}`;
            xTitle = `${utils.dict().screenLibrary[userInput.l]} ${utils.dict().cellLine[userInput.cl]} ${utils.dict().conditionPair[userInput.c]} - ${utils.extents()[type].xMetric}`;
        } else {
            type="volcano";
            yTitle = utils.extents()[type].yMetric;
            xTitle = utils.extents()[type].xMetric;
        }
        return {
            x: {
                label:utils.extents()[type].xMetric,
                min: utils.extents()[type].x[0],
                max: utils.extents()[type].x[1],
                title: xTitle
            },
            y: {
                label: utils.extents()[type].yMetric,
                min: utils.extents()[type].y[0],
                max: utils.extents()[type].y[1],
                title: yTitle
            }
        }

    }
    let scale = ()=>{
        return { 
             x: d3.scaleLinear().domain([plotConfig.axis.x.min, plotConfig.axis.x.max]).range([0, plotConfig.innerWidth]),
             y: d3.scaleLinear().domain([plotConfig.axis.y.min, plotConfig.axis.y.max]).range([plotConfig.innerHeight, 0])
         }
    }

    plotConfig.innerWidth = plotConfig.width - plotConfig.padding.left - plotConfig.padding.right;
    plotConfig.innerHeight = plotConfig.height - plotConfig.padding.top - plotConfig.padding.bottom;
    plotConfig.axis = axis();
    plotConfig.scale = scale();

    return plotConfig
}

export function render(data, config, userInput){
    d3.selectAll(".ljs--lattice-plot").classed("active", false)
        .filter(d=>{
            return d._userInput.key == userInput.cl; 
        })
        .classed("active", true)

    brushCoords = undefined; // clear brush when rendered (ie: changing underlying data)
    let plotConfig = createPlotConfig(config, userInput);

    const container = d3.select(`#${config.rootId}`)
        .style("width", plotConfig.width + "px")
        .style("height", plotConfig.height + "px")
    const svg = container.append('svg')
        .attr('width', plotConfig.width)
        .attr('height', plotConfig.height)
        .attr('class', 'svg-plot')
    const svgChart = svg
        .append('g')
        .attr('transform', `translate(${plotConfig.padding.left}, ${plotConfig.padding.top})`);

    d3.select(".svg-plot")
        .append("text")
        .attr("class", "plot-title")
        .attr("x", plotConfig.width/2)
        .attr("y", 0)

        .attr("text-anchor", "middle")
        .html(function(){
            var x = d3.select(this).attr("x");
            var y =  14;
            if (userInput.scatter){
                return `<tspan x=${+x} dy=${y}>${utils.dict().cellLine[userInput.cl]} ${utils.dict().screenLibrary[userInput.l]} ${utils.dict().conditionPair[userInput.c]}</tspan>
                <tspan class="light" x=${+x} dy=${+y}>versus</tspan>
                <tspan  x=${+x} dy=${+y}>${utils.dict().cellLine[userInput.cl2]} ${utils.dict().screenLibrary[userInput.l]} ${utils.dict().conditionPair[userInput.c2]}</tspan>`
            } else {
                return `<tspan x=${+x} dy=${y}>${utils.dict().cellLine[userInput.cl]} ${utils.dict().screenLibrary[userInput.l]}</tspan>
                <tspan class="light" x=${+x} dy=${+y}>${utils.dict().conditionPair[userInput.c]}</tspan>`
            }
        }) 
    
    svgChart.append("line")
        .attr("x1", plotConfig.scale.x(0))
        .attr("x2", plotConfig.scale.x(0))
        .attr("y1", plotConfig.scale.y(plotConfig.scale.y.domain()[0]))
        .attr("y2", plotConfig.scale.y(plotConfig.scale.y.domain()[1]) - 10)
        .attr("class", "dashed-line") 

    if (userInput.scatter == true){
        svgChart.append("line")
            .attr("x1", plotConfig.scale.x(plotConfig.scale.x.domain()[0]))
            .attr("x2", plotConfig.scale.x(plotConfig.scale.x.domain()[1]))
            .attr("y1", plotConfig.scale.y(0))
            .attr("y2", plotConfig.scale.y(0))
            .attr("class", "dashed-line")
    }

    // Init Canvas
    const canvasChart = container.append('canvas')
        .attr('width', plotConfig.innerWidth)
        .attr('height', plotConfig.innerHeight)
        .style('margin-left', plotConfig.padding.left + 'px')
        .style('margin-top', plotConfig.padding.top + 'px')
        .attr('class', 'canvas-plot');
    
    const context = canvasChart.node().getContext('2d');
    // Init Axis
    const xAxis = d3.axisBottom(plotConfig.scale.x).ticks(7);
    const yAxis = d3.axisLeft(plotConfig.scale.y).ticks(7);
    
    // Add Axis
    const gxAxis = svgChart.append('g')
        .attr("class", "focus-axis")
        .attr('transform', `translate(0, ${plotConfig.innerHeight})`)
        .call(xAxis);
    
    const gyAxis = svgChart.append('g')
        .attr("class", "focus-axis")
        .call(yAxis);
    
    // Add labels
    svgChart.append('text')
        .attr('x', `-${plotConfig.innerHeight/2}`)
        .attr("y", -plotConfig.padding.left/2)
        .attr('dy', '-1em')
        .attr('transform', 'rotate(-90)')
        .attr("text-anchor", "middle")
        .attr("class", "axis-title")
        .text(plotConfig.axis.y.title)

    svgChart.append('text')
        .attr('x', `${plotConfig.innerWidth/2}`)
        .attr('y', `${plotConfig.innerHeight + (plotConfig.padding.bottom/2)}`)
        .attr("text-anchor", "middle")
        .attr('dy', '1em')
        .attr("class", "axis-title")
        .text(plotConfig.axis.x.title)

    const brush = d3.brush()
        .extent([[0, 0], [plotConfig.innerWidth, plotConfig.innerHeight]])
        .on("end", brushed)

    svgChart.append("g")
        .attr("class", "brush")
        .call(brush);

    draw() // gets called again on brush
    table.render(data, plotConfig) 
    eventListener(plotConfig, userInput, data)

    function draw() {
        const scaleX = plotConfig.scale.x;
        const scaleY = plotConfig.scale.y;

        gxAxis.call(xAxis.scale(scaleX));
        gyAxis.call(yAxis.scale(scaleY));
    
        context.clearRect(0, 0, plotConfig.innerWidth, plotConfig.innerHeight);

        data.forEach(point => {
            point.c = setPointColor(brushCoords, scaleX(point.x), scaleY(point.y)) // checks if point is within brush area to assign/return a color 
            context.globalAlpha = 0.2;
            context.beginPath();
            context.fillStyle = point.c;
            const px = plotConfig.scale.x(point.x);
            const py =  plotConfig.scale.y(point.y);
            context.arc(px, py, point.r, 0, 2 * Math.PI, true);
            context.fill();
        });
    }

    function brushed(event) {
        const selection = event.selection;
        if (selection != null) {
            brushCoords = selection;
            let tableData = filterData(data, brushCoords, plotConfig.scale.x, plotConfig.scale.y)
            draw()  
            table.render(tableData, plotConfig) 
            eventListener(plotConfig, userInput, tableData)
        } else {
            brushCoords = undefined;           
            draw()
            table.render(data, plotConfig) 
            eventListener(plotConfig, userInput, data)
        }
    }
}


function eventListener(plotConfig, userInput, data){
    resetGene()

    const tree = d3.quadtree()
        .x(d=> d.x)
        .y(d=> d.y)
        .extent([[0, 0], [plotConfig.innerWidth, plotConfig.innerHeight] ])    
        .addAll(data);


    d3.select(".svg-plot g")
        .on("mousemove",function(event){
            let mouse = d3.pointer(event),
                closest = tree.find( plotConfig.scale.x.invert(mouse[0]), plotConfig.scale.y.invert(mouse[1]) ),
                distance = utils.euclidDistance(closest.x,closest.y, plotConfig.scale.x.invert(mouse[0]), plotConfig.scale.y.invert(mouse[1]))
             
                let circleClick = function(d,e){
                    clearPoint("mouseover")
                    renderPoint(plotConfig, filterPoint(data, closest.series), "click")
                    table.filterColumn(e.series)
                    geneView.launch(userInput, e.series)
                }
                let circleMouseover = function(){
                    renderPoint(plotConfig, filterPoint(data, closest.series), "mouseover")

                    d3.select("#focus-plot-tooltip")
                        .style("left", `${mouse[0]+70}px`)
                        .style("top", `${mouse[1]}px`)
                        .html(`Gene: ${closest.series}<br>${plotConfig.axis.x.label}: ${closest.x}<br>${plotConfig.axis.y.label}: ${closest.y}`)
                        .classed("hidden", false)
                }
        
            if (distance <=0.5){
                circleMouseover()
              
                d3.selectAll("circle.mouseover")
                    .on("click", circleClick)

            } else {
                d3.select("#focus-plot-tooltip").classed("hidden", true)
                clearPoint("mouseover")
            }
        });


    let rowClick = function(){
        const dTable = $(`#table`).DataTable();
      //  const row = dTable.row($(this))
        const rowData = dTable.row($(this)).data();

        // if ($(row.node()).hasClass('click'))
        //     return; // do nothing if row is already selected
        // else {
            $('tr').removeClass('click')
            $(this).addClass('click')
            renderPoint(plotConfig, [rowData], "click")
            geneView.launch(userInput, rowData.series)
       // }
    }
    let rowMouseover = function(){
        const dTable = $(`#table`).DataTable();
      //  const row = dTable.row($(this))
        const rowData = dTable.row($(this)).data();
        // if ($(row.node()).hasClass('mouseover'))
        //     return; // do nothing if row is already selected
        // else {
            $('tr').removeClass('mouseover')
            $(this).addClass('mouseover')
            renderPoint(plotConfig, [rowData], "mouseover")
       // }
    }
    let rowMouseleave = function(){
        $(this).removeClass('mouseover')
        clearPoint("mouseover")
    }

    $('#table tbody')
        .on('click', 'tr', rowClick)
        .on('mouseover', 'tr', rowMouseover)
        .on('mouseleave', 'tr', rowMouseleave)

    $(".custom-pill").on("click", function(){
        resetGene()
    })

}

function resetGene(){   
    clearPill()
    clearPoint("click")
    table.clearColumnFilter()
    geneView.clear()
}

function renderPoint(plotConfig, data, event){

    let scaleX = plotConfig.scale.x,
        scaleY = plotConfig.scale.y;

    let plot = d3.select(".svg-plot g")
   // plot.selectAll("circle").remove();

    let circle = plot.selectAll(`.${event}`)
       .data(data)
  
    circle.exit().remove()
    circle.enter().append("circle")
        .merge(circle)
        .attr("cx", d=>scaleX(d.x))
        .attr("cy", d=>scaleY(d.y))
        .attr("r",d=>d.r*1.2)
        .attr("class", `${event}`)
}

function clearPoint(point){
    d3.select(".svg-plot g").selectAll(`.${point}`).remove();
}
function clearPill(){
    $(".custom-pill").html(``).addClass("hidden")
}